export default __webpack_public_path__ + "static/media/red_pawn.11eeb3a3.png";